// Ukrainian grammatical forms for the route recurrence options.
// Ukrainian requires the genitive case here (not the nominative Intl gives), and the
// determiner + ordinal must agree with the weekday's gender:
//   every  -> "Кожного понеділка" (m) / "Кожної неділі" (f)
//   Nth    -> "Лише кожного 2-го понеділка щомісяця" (m) / "Лише кожної 2-ї неділі щомісяця" (f)
// Weekday index is Monday=0..Sunday=6 (matches Route.day_of_the_week).

const UK_WEEKDAY = {
  0: { gen: "понеділка", g: "m" }, // понеділок
  1: { gen: "вівторка", g: "m" }, // вівторок
  2: { gen: "середи", g: "f" }, // середа
  3: { gen: "четверга", g: "m" }, // четвер
  4: { gen: "п'ятниці", g: "f" }, // п'ятниця
  5: { gen: "суботи", g: "f" }, // субота
  6: { gen: "неділі", g: "f" }, // неділя
};

const UK_ORDINAL_GEN = {
  m: { 1: "1-го", 2: "2-го", 3: "3-го", 4: "4-го", 5: "5-го" },
  f: { 1: "1-ї", 2: "2-ї", 3: "3-ї", 4: "4-ї", 5: "5-ї" },
};

export const ukEvery = wd => {
  const w = UK_WEEKDAY[wd];
  if (!w) return "";
  return `${w.g === "m" ? "Кожного" : "Кожної"} ${w.gen}`;
};

export const ukNth = (wd, nth) => {
  const w = UK_WEEKDAY[wd];
  if (!w) return "";
  const determiner = w.g === "m" ? "кожного" : "кожної";
  const ord = (UK_ORDINAL_GEN[w.g] || {})[nth] || `${nth}-${w.g === "m" ? "го" : "ї"}`;
  return `Лише ${determiner} ${ord} ${w.gen} щомісяця`;
};

// "Once every two weeks", said as the pair of Nth slots that encodes it: the ordinals agree
// with the weekday's gender, same as ukNth.
export const ukBiweekly = (wd, [a, b]) => {
  const w = UK_WEEKDAY[wd];
  if (!w) return "";
  const ords = UK_ORDINAL_GEN[w.g] || {};
  return `Раз на два тижні (${ords[a] || a} і ${ords[b] || b} ${w.gen})`;
};
